import React, { Component } from 'react';
import './App.css';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import TextField from '@material-ui/core/TextField';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import Vote from './Vote.js';
import Iframe from 'react-iframe';
import 'react-autocomplete-input/dist/bundle.css';
import InfoIcon from "./infoicon";
import Select from "react-select";
import { withStyles } from "@material-ui/core/styles";
import { compressImage, uploadPhoto, retryPendingUploads } from './photoUpload';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import MomentUtils from "@date-io/moment";
import moment from 'moment-timezone';

const styles = theme => ({
  root: {
    padding: "none"
  },
  textField: {
    width: "11rem",
    height: "2.75rem",
    background: "#ffffff",
    border: "1.5px solid #e8e9ed",
    borderRadius: "0.5rem",
    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
    padding: "0.625rem 0.875rem",
    boxSizing: 'border-box',
    transition: "border-color 150ms ease, box-shadow 150ms ease",
    "&:hover": {
      borderColor: "#8e8e9a",
    },
    "&:focus-within": {
      borderColor: "#4b1f7d",
      boxShadow: "0 0 0 3px rgba(75, 31, 125, 0.1)",
    },
  },
  dateTestfield: {
    border: "1.5px solid #e8e9ed",
    width: "10rem",
    minWidth: "10rem",
    height: "2.75rem",
    backgroundColor: "#ffffff",
    padding: "0rem 0rem 0rem 0.875rem",
    borderRadius: "0.5rem",
    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
    boxSizing: 'border-box',
    transition: "border-color 150ms ease, box-shadow 150ms ease",
    "&:hover": {
      borderColor: "#8e8e9a",
    },
    "&:focus-within": {
      borderColor: "#4b1f7d",
      boxShadow: "0 0 0 3px rgba(75, 31, 125, 0.1)",
    },
  }
});



const sentiment = [
  {value: 'Excellent', label: 'Excellent'},
  {value: 'Good', label: 'Good'},
  {value: 'Average', label: 'Average'},
  {value: 'Poor', label: 'Poor'},
  ];


const zipcodess = [
{value: "Aldrich", label: 'Aldrich'},
{value: "Butte", label: 'Butte'},
{value: "Butte/Padre", label:'Butte/Padre'},
{value: "Carmel", label:'Carmel'},
{value: "Fritz", label:'Fritz'},
{value: "Independence", label:'Independence'},
{value: "Monterey", label:'Monterey'},
{value: "Nonpareil", label:'Nonpareil'},
{value: "Padre", label:'Padre'},
{value: "Shasta", label:'Shasta'},
{value: "Sonora", label:'Sonora'},
{value: "Wood Colony", label:'Wood Colony'},
{value: "California", label:'California'}
];

const almondVariety = [
{value: "Unknown", label:'Unknown'},
{value: "Aldrich", label:'Aldrich'},
{value: "Butte", label:'Butte'},
{value: "Butte/Padre", label:'Butte/Padre'},
{value: "Carmel", label:'Carmel'},
{value: "Fritz", label:'Fritz'},
{value: "Independence", label:'Independence'},
{value: "Monterey", label:'Monterey'},
{value: "Nonpareil", label:'Nonpareil'},
{value: "Padre", label:'Padre'},
{value: "Shasta", label:'Shasta'},
{value: "Sonora", label:'Sonora'},
{value: "Wood Colony", label:'Wood Colony'},
{value: "California", label:'California'}
];


const bloomStage = [
  {value: 'Green Tip', label: 'Green Tip'},
  {value: 'Pink Bud', label: 'Pink Bud'},
  {value: 'Popcorn', label: 'Popcorn'},
  {value: 'Early Bloom', label: 'Early Bloom'},
  {value: 'Full Bloom', label: 'Full Bloom'},
  {value: 'Petal Fall', label: 'Petal Fall'}
  ];

const selectCustomStyles = {
  menu: (provided, state) => ({
    ...provided,
    background: "#ffffff",
    borderRadius: "0.5rem",
    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    border: "1px solid #e8e9ed",
    marginTop: "4px",
    overflow: "hidden",
    zIndex: 100,
  }),
  menuList: (provided, state) => ({
    ...provided,
    padding: "4px",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#4b1f7d" : state.isFocused ? "#f8f9fc" : "#ffffff",
    color: state.isSelected ? "#ffffff" : "#1a1a2e",
    padding: "10px 12px",
    borderRadius: "0.375rem",
    cursor: "pointer",
    fontSize: "14px",
    transition: "background-color 150ms ease",
    "&:active": {
      backgroundColor: state.isSelected ? "#4b1f7d" : "#f0f1f5",
    },
  }),
  control: (provided, { selectProps, isFocused }) => ({
    ...provided,
    background: "#ffffff",
    display: "flex",
    width: "10rem",
    minHeight: "2.75rem",
    height: "2.75rem",
    paddingLeft: "0.5rem",
    cursor: "pointer",
    fontFamily: "Sofia Pro",
    fontSize: "14px",
    border: selectProps.hasError
      ? "1.5px solid #ef4444"
      : isFocused
        ? "1.5px solid #4b1f7d"
        : "1.5px solid #e8e9ed",
    borderRadius: "0.5rem",
    boxShadow: isFocused ? "0 0 0 3px rgba(75, 31, 125, 0.1)" : "0 1px 2px rgba(0, 0, 0, 0.05)",
    transition: "all 150ms ease",
    "&:hover": {
      borderColor: selectProps.hasError ? "#ef4444" : "#8e8e9a",
    },
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: "#1a1a2e",
    fontSize: "14px",
  }),
  placeholder: (provided, state) => ({
    ...provided,
    color: "#8e8e9a",
    fontSize: "14px",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: "#8e8e9a",
    padding: "8px",
    transition: "transform 150ms ease",
    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0deg)",
    "&:hover": {
      color: "#4b1f7d",
    },
  }),
};

const filterOptions = createFilterOptions({
  matchFrom: 'start',
  stringify: option => option,
});

const formFields = {
  email : { required: false },
  date : { required: true },
  location: { required: true },
  almond_variety: { required: true },
  bloom_stage: { required: true },
  bloom_sent: { required: true },
  bee_flight: { required: true }
};

const getToday = function () {
   var d = new Date(),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [month, day, year].join('/');
}

const defaultDate = moment().tz("America/Los_Angeles").format("MM/DD/YYYY")
const defaultFormatDate = moment().tz("America/Los_Angeles").format("YYYY-MM-DD")

class App extends Component {
  constructor(props) {
    super(props);

    // init state for form fields
    let initStateObj = {};
    for (var key in formFields) {
      initStateObj[key]= null;
    }

    // add custom state for error
    initStateObj['date'] = defaultFormatDate;
    initStateObj['inputValue'] = defaultDate;
    initStateObj['error'] = null;
    initStateObj['vote_submitted'] = false;
    initStateObj['show_error'] = false;
    initStateObj['zipcodes'] = [];
    initStateObj['almond_variety'] = null;
    initStateObj['bloom_stage'] = null;
    initStateObj['bloom_sent'] = null;
    initStateObj['verification'] = 'failed';
    initStateObj['votes'] = null;
    initStateObj['iframe_url'] = '/map.html?showdata=1&regionId=2';
    initStateObj['existing_email'] = '';
    initStateObj['form_message'] = '';
    initStateObj['photo_file'] = null;
    initStateObj['photo_preview'] = null;
    initStateObj['photo_uploading'] = false;
    initStateObj['photo_caption'] = '';
    initStateObj['photo_message'] = '';



    // set and init state
    this.state = initStateObj;

    this.handleChange = this.handleChange.bind(this);
    this.handleSpecialChange = this.handleSpecialChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    retryPendingUploads();

    let search = window.location.search;
    let params = new URLSearchParams(search);
    let verification = params.get("verify");

    if (verification) {
      fetch("/api/verify", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ verification: verification }),
      }).then((response) => {
        if (!response.ok) {
          this.setState({ verification: "fail" });
        } else {
          response.json().then((data) => {
            let email = '';
            let regionId = '';
            if(data.votes.length > 0){
              email = data.votes[0].email;
              regionId = data.votes[0].region_id;
            }

            this.setState({
              verification: "verified",
              votes: data.votes,
              iframe_url: '/map.html?showdata=1&regionId='+regionId,
              email: email,
              existing_email: email
            });
          });
        }
      });
    }

    // ----------------------------
    fetch('/api/get_zipcodes', {
        method: 'GET'
    })
    .then(response =>{
      if(!response.ok){

      }else {
        response.json().then(data => {
          this.setState({zipcodes: data.zipcodes})
        });
      }
    });
  }

  // hanlde selection change
  handleChange(event) {
    const value = event.target.value;
    this.setState({
      [event.target.name]: value,
      form_message: ''
    });
  }

  // handle selection change for special inputs
  handleSpecialChange(name, a, value) {
    this.setState({
      [name]: value,
      form_message: ''
    });
  }
  //handle date change
  handleDateChange = (date, value) => {
    this.setState({
      date: moment(date).format("YYYY-MM-DD"),
      inputValue: value
    })
  }
  dateFormatter = str => {
    return str;
  };
  handleSelectedValue = (e, name) => {
    this.setState({
      [name]: e.value,
      form_message: ''
    })
  }

  handlePhotoChange = (event) => {
    var file = event.target.files[0];
    if (!file) return;

    if (file.size > 15 * 1024 * 1024) {
      this.setState({ error: 'Photo must be under 15MB.', show_error: true });
      return;
    }

    var reader = new FileReader();
    var self = this;
    reader.onload = function(e) {
      self.setState({ photo_preview: e.target.result });
    };
    reader.readAsDataURL(file);
    this.setState({ photo_file: file, form_message: '', photo_message: '' });
  }

  handleRemovePhoto = () => {
    this.setState({ photo_file: null, photo_preview: null, photo_caption: '', photo_message: '' });
  }

  handleCaptionChange = (event) => {
    this.setState({ photo_caption: event.target.value });
  }

  // submit vote
  handleSubmit(event) {
    event.preventDefault();


    let {
      email,
      date,
      location,
      almond_variety,
      bee_flight,
      bloom_sent,
      bloom_stage,
      verification,
      existing_email
    } = this.state;

    // validate state
    for( var key in formFields){
      if(this.state[key] == null && formFields[key].required){
        this.setState({
          error:"Please enter all required fields.",
          show_error:true,
        });
        return;
      }
    }

    // validate email format if provided
    if (email && email.trim() !== '') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email.trim())) {
        this.setState({
          error: "Please enter a valid email address.",
          show_error: true,
        });
        return;
      }
    }

    // if user has been verfied, double check email has not change
    if(existing_email && email && existing_email !== email){
      verification = 'failed';
      this.setState({
        verification: "failed"
      });
    }

    fetch('/api/save_bloom', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email,
          date,
          location,
          almond_variety,
          bee_flight,
          bloom_sent,
          bloom_stage,
          verification})
    })
    .then(response =>{
      if(!response.ok){
        this.setState({
          show_error:true,
          error: "An error occured submitting your vote.",
        })
      }else {

        response.json().then((data) => {

          if(this.state.iframe_url === '/map.html?showdata=1'){
            //document.getElementById('myMapId').contentWindow.location.reload();
          }

          // Vote succeeded - now handle photo upload in background
          var photoFile = this.state.photo_file;
          var photoCaption = this.state.photo_caption;
          var self = this;

          this.setState({
            vote_submitted:true,
            show_error:false,
            iframe_url: '/map.html?showdata=1&regionId='+data.regionId[0].id+'&'+Date.now(),
            date:  date,
            almond_variety: null,
            bloom_stage: null,
            votes: data.votes,
            location: null,
            bloom_sent: null,
            bee_flight: null,
            form_message: (data.confirmed ? 'Success!' : 'Success! Check your email to save your vote.'),
            photo_file: null,
            photo_preview: null,
            photo_caption: ''
          });

          // Upload photo in background (don't block vote confirmation)
          if (photoFile) {
            self.setState({ photo_uploading: true, photo_message: 'Uploading photo...' });
            compressImage(photoFile).then(function(compressed) {
              return uploadPhoto({
                file: compressed,
                email: email,
                bloomVoteId: data.vote_id,
                zipcode: location,
                caption: photoCaption
              });
            }).then(function(result) {
              if (result.success) {
                self.setState({ photo_uploading: false, photo_message: 'Photo uploaded!' });
              } else if (result.pending) {
                self.setState({ photo_uploading: false, photo_message: 'Photo will upload when connection improves.' });
              } else {
                self.setState({ photo_uploading: false, photo_message: 'Photo upload failed.' });
              }
            }).catch(function(err) {
              console.log('Photo upload error:', err);
              self.setState({ photo_uploading: false, photo_message: 'Photo will upload when connection improves.' });
            });
          }
        });
      }
    });
  }

  render() {
    const { classes } = this.props;

    return (
      <div className="App">
        <Container width="100%" maxWidth={false} height="1000px">
          <Box display="flex" p={0} bgcolor="background.paper" height="100%">
            <Box p={0} width="30%" bgcolor="#ffffff">
              <div className="header-container">
                <a target= "_blank" href = "https://app.bountiful.ag"><img className="header-logo" src="/images/bountiful-logo-purple.png" alt="bountiful_logo" /></a>
                <a target= "_blank" href = "https://app.bountiful.ag"><img className="header-text" src="/images/bountiful-heading-3x.png"/></a>
              </div>
              <div className="instructions">
              Complete the fields below and click 'Submit' to update the bloom, bee flight, and chill portion data on the map. To save your observations and receive daily bloom status emails, enter your email address.
              </div>
              <Vote votes={this.state.votes} verification={this.state.verification}/>
              <form onSubmit={this.handleSubmit}>
              { /* EMAIL */}

                <div className="input-field-container">
                  <span class="form-label">Email (Optional)</span>
                  <input
                    className={"input-field" + (this.state.error === "Please enter a valid email address." && this.state.show_error ? " error" : "")}
                    id="email"
                    value={this.state.email}
                    name="email"
                    variant="outlined"
                    label="Optional"
                    placeholder="Enter Your Email"
                    onChange={this.handleChange}
                  />
                  <InfoIcon text="Enter your email to save your observation and receive daily bloom emails. Submtting will send a link to your email to view past observations." />
                </div>

                { /* DATE */}
                <div className="input-field-container">
                  <span class="form-label">Date</span>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      className={classes.dateTestfield}
                      disableToolbar
                      variant="inline"
                      format="MM/dd/yyyy"
                      margin="normal"
                      name="date"
                      id="date-picker-dialog"
                      value={this.state.inputValue}
                      inputValue={this.state.inputValue}
                      onChange={this.handleDateChange}
                      maxDate={defaultDate}
                      autoOk={true}
                      rifmFormatter={this.dateFormatter}
                      KeyboardButtonProps={{
                        'aria-label': 'change date'
                      }}
                    />
                  </MuiPickersUtilsProvider>
                  <InfoIcon text="This defaults to current day. Select past days to submit observations for historical data." />
                </div>


                 { /* Location */}
                <div className="input-field-container">
                  <span class="form-label">Zipcode</span>
                  <Select
                    styles={selectCustomStyles}
                    isSearchable={true}
                    hasError={this.state.error === "Please enter all required fields." && this.state.show_error && this.state.location == null} // Pass error state
                    components={{
                      DropdownIndicator: () => null,
                      IndicatorSeparator: () => null,
                    }}
                    onChange={(e)=> this.handleSelectedValue(e, "location")}
                    options={this.state.zipcodes}
                    value={this.state.zipcodes.filter((option) => option.value === this.state.location)}
                    placeholder="Required" />
                  <InfoIcon text="We collect data by zipcode but display state and region level." />
                </div>

                { /* ALMOND VARIETY */}
                <div className="input-field-container">
                  <span class="form-label">Almond Variety</span>
                  <Select
                    styles={selectCustomStyles}
                    isSearchable={true}
                    hasError={this.state.error === "Please enter all required fields." && this.state.show_error && this.state.almond_variety == null} // Pass error state
                    components={{
                      DropdownIndicator: () => null,
                      IndicatorSeparator: () => null,
                    }}
                    onChange={(e)=> this.handleSelectedValue(e, "almond_variety")}
                    options={almondVariety}
                    value={almondVariety.filter((option) => option.value === this.state.almond_variety)}
                    placeholder="Required" />
                  <InfoIcon text="Select the almond variety which is most representative for your observation. If you don't know the variety, select the 'Unknown' option. Data displayed for all varieties." />
                </div>

                { /* BLOOM STAGE */}
                <div className="input-field-container">
                  <span class="form-label">Bloom Stage(<a target="_blank" href="https://7462576.fs1.hubspotusercontent-na1.net/hubfs/7462576/Bountiful%20Bloom%20Tracking%20Final.pdf">&#63;</a>)</span>
                  <Select
                    styles={selectCustomStyles}
                    isSearchable={true}
                    hasError={this.state.error === "Please enter all required fields." && this.state.show_error && this.state.bloom_stage == null} // Pass error state
                    components={{
                      IndicatorSeparator: () => null,
                      DropdownIndicator: () => null,
                    }}
                    onChange={(e)=> this.handleSelectedValue(e, "bloom_stage")}
                    options={bloomStage}
                    value={bloomStage.filter((option) => option.value === this.state.bloom_stage)}
                    placeholder="Required" />
                  <InfoIcon text="Select the bloom stage that is most representative for your observation. Click the icon next to 'Stage' for bloom stage references. Hover over the bloom map to see a realtime breakdown of current bloom stage." />
                </div>

                { /* BLOOM SENT */}
                <div className="input-field-container">
                  <span class="form-label">Bloom Sentiment</span>
                  <Select
                    styles={selectCustomStyles}
                    isSearchable={true}
                    hasError={this.state.error === "Please enter all required fields." && this.state.show_error && this.state.bloom_sent == null} // Pass error state
                    components={{
                      IndicatorSeparator: () => null,
                      DropdownIndicator: () => null,
                    }}
                    onChange={(e)=> this.handleSelectedValue(e, "bloom_sent")}
                    options={sentiment}
                    value={sentiment.filter((option) => option.value === this.state.bloom_sent)}
                    placeholder="Required" />
                  <InfoIcon text="Select the option that is most representative for your observation. Overall sentiment is shown on the bloom map hover over once observations are submitted." />
                </div>

                { /* BEE FLIGHT */}
                <div className="input-field-container">
                <span class="form-label">Bee Activity</span>
                <Select
                    styles={selectCustomStyles}
                    isSearchable={true}
                    hasError={this.state.error === "Please enter all required fields." && this.state.show_error && this.state.bee_flight == null} // Pass error state
                    components={{
                      IndicatorSeparator: () => null,
                      DropdownIndicator: () => null,
                    }}
                    onChange={(e)=> this.handleSelectedValue(e, "bee_flight")}
                    options={sentiment}
                    value={sentiment.filter((option) => option.value === this.state.bee_flight)}
                    placeholder="Required" />
                  <InfoIcon text="Select the option that is most representative for your observation." />
                </div>

                { /* PHOTO UPLOAD */}
                <div className="input-field-container">
                  <span className="form-label">Photo (Optional)</span>
                  <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '0.5rem'}}>
                    <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                      <label style={{
                        display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem',
                        width: '10rem', height: '2.75rem', boxSizing: 'border-box',
                        border: '1.5px dashed #e8e9ed', borderRadius: '0.5rem',
                        cursor: 'pointer', fontSize: '14px',
                        fontFamily: 'Sofia Pro', color: '#4a4a68', backgroundColor: '#f8f9fc',
                        transition: 'border-color 150ms ease'
                      }}>
                        <span>{this.state.photo_file ? '📷 Change' : '📷 Add Photo'}</span>
                        <input
                          type="file"
                          accept="image/*"
                          capture="environment"
                          onChange={this.handlePhotoChange}
                          style={{display: 'none'}}
                        />
                      </label>
                      {this.state.photo_file && (
                        <button type="button" onClick={this.handleRemovePhoto}
                          style={{background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '13px', fontFamily: 'Sofia Pro', padding: 0}}>
                          ✕
                        </button>
                      )}
                    </div>
                    {this.state.photo_preview && (
                      <img src={this.state.photo_preview} alt="Preview"
                        style={{maxWidth: '100px', maxHeight: '80px', borderRadius: '0.5rem', objectFit: 'cover', border: '1px solid #e8e9ed'}} />
                    )}
                    {this.state.photo_uploading && (
                      <div style={{fontSize: '12px', color: '#4b1f7d'}}>Uploading...</div>
                    )}
                    {this.state.photo_message && !this.state.photo_uploading && (
                      <div style={{fontSize: '12px', color: this.state.photo_message.includes('failed') || this.state.photo_message.includes('improves') ? '#f59e0b' : '#10b981', textAlign: 'right'}}>{this.state.photo_message}</div>
                    )}
                  </div>
                  <InfoIcon text="Optional: add a photo of trees showing current bloom stage." />
                </div>

                {
                  this.state.vote_submitted ? (<div className="success-msg">{this.state.form_message}</div>) : ""
                }
                {
                  this.state.show_error ? <div className="error-msg">{this.state.error}</div> : ""
                }
               {/*<button className="btn" type="submit" >Submit</button>*/}

              </form>
              <div className="vote-ended">Observations ended on 3/3/2026</div>

              
              

              <div className="contact">
                <div>Contact Us</div>
                <div><a href={"mailto:hello@bountiful.ag"}>hello@bountiful.ag</a></div>
                <div>(805) 704-7157</div>
              </div>
              <div id ='sec'><a target="_blank" href="https://app.termly.io/document/privacy-policy/d409c2a1-6aa2-4ff4-838e-78093046d705">Privacy Policy</a><a target="_blank" href="https://app.termly.io/document/terms-of-use-for-saas/c1e8fb35-9953-4459-8e4e-eb539c6b6669">Terms and Conditions</a></div>
            </Box>
            <Box p={0} width="70%" flexShrink={1}>
              <Iframe url={this.state.iframe_url}
                width="100%"
                height="100%"
                id="myMapId"
                className="myClassname"
                display="initial"
                position="relative"
                frameBorder="0"
                />
            </Box>
          </Box>
        </Container>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(App);
